import { render, staticRenderFns } from "./ProgressPopUp.vue?vue&type=template&id=b635e756&"
import script from "./ProgressPopUp.vue?vue&type=script&lang=js&"
export * from "./ProgressPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports